// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"0dd30ee5","602":"5ea929d8"}[chunkId] + ".chunk.js";
};